<template>
    <div>
        <div class="page-top mb-1 mb-3 align-center clearfix">
            <h1 class="float-left"> Students/Members</h1>
                <router-link to="/feeBulkUploadStudents" class="btn btn-primary float-right active"> Bulk Upload </router-link>
                <router-link to="/feeAddStudent" class="btn btn-primary float-right active mr-1"> Add </router-link>
            <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" name="" />
            </div>
        </div>
        <table id="studentsTable" class="table">
            <thead>
                <tr>
                    <th style="display: none;"></th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Campus/Branch Name</th>
                    <th>Mobile Number</th>
                    <th>CNIC</th>
                    <th>Email Address</th>
                    <th>Action</th>
                </tr>
            </thead>
        </table>
    </div>
</template>

<script>
    var that = null;
    export default {
        data() {
            return {
                data : null,
                studentsTable: null
            };
        },
        methods :{
            deleteStudents(id){
                that.$Progress.start();
                axios.get('/api/deleteStudentById/'+id)
                .then(result => {
                    if(result.status == 200){
                        if(result.data.code == 200){
                            that.showToastBox('success','Student has been deleted');
                            that.studentsTable.ajax.reload();
                        }else{
                            that.showToastBox('error','Error in deleting student');
                        }
                    }
                    that.$Progress.finish();
                })
                .catch(error => {
                    that.$Progress.fail();
                });
            }
        },
        mounted() {
            that = this;
            this.$Progress.start();
            this.studentsTable = $('#studentsTable').DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                processing: true,
                serverSide: true,
                ajax: {
                    "url": "api/listFeeStudents",
                    "headers": window.axios.defaults.headers.common,
                    "dataSrc": "records",
                },
                deferRender: true,
                columns: [
                    {data: 'id', visible: false},
                    {data: 'student_id'},
                    {data: 'name'},
                    {data: 'campus.name'},
                    {data: 'mobile_number'},
                    {data: 'cnic_number'},
                    {data: 'email_address'},
                    {data: 'id',orderable:false, render: function(data,type,full){

                        var $url = '/feeStudentEdit/'+full['id'];
                        return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"><i class="fas fa-pencil-alt"></i> </a><a href="javascript:void(0);" onclick="VueComponents.feeStudentsComponent.methods.deleteStudents('+full["id"]+')" data-toggle="tooltip" data-placement="top" title="" class="action text-center" data-original-title="Delete"> <i class="fas fa-trash"></i> </a> </td>';
                    }}
                ],
                "order": [[ 0, "desc" ]],
                "columnDefs": [{
                    className: "text-center",
                    "targets": [ 4 ]
                }],
                "initComplete": () => {
                    this.$Progress.finish();
                }
            });
             $('#customSearch').on( 'keyup', function () {
                that.studentsTable.search(this.value).draw();
            });
        },
        created() {
            //
        }
    }
</script>
